import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { appTitle } from "../common/GeneralConfigurations";
import WelcomeSessionListForm from "./WelcomeSessionListForm";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import {
  getWelcomeSessionEmployees,
  getWelcomeSessionExcel,
  notifyConsultants,
} from "../../api/WelcomeSessionApi";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";

const ManageWelcomeSessionListPage = () => {
  const { t } = useTranslation();
  const title = t("welcomeSession.title");
  const REPORT_NAME = t("welcomeSession.reports.welcomeSession");
  const daysInAdentis = 90;

  const [employeesList, setEmployeesList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [employeeIds, setEmployeeIds] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [welcomeSessionDateTime, setWelcomeSessionDateTime] = useState();

  useEffect(() => {
    document.title = `${appTitle} - ${title}`;

    getNewConsultants();
  }, []);

  const getNewConsultants = async () => {
    await getWelcomeSessionEmployees(daysInAdentis)
      .then((res) => {
        if (res.status == 200) {
          setEmployeesList(res.data);
          setTotalRecords(res.data.length);
        } else if (res && res.data && res.data.errors) {
          res.data.errors.map((e) => {
            AdnMessageError(e.message);
          });
        } else {
          AdnMessageError(t("welcomeSession.messages.couldNotGetEmployees"));
        }
      })
      .catch(() => {
        AdnMessageError(t("welcomeSession.messages.couldNotGetEmployees"));
      });
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setEmployeeIds(newSelectedRowKeys);
  };

  const rowSelection = {
    employeeIds,
    onChange: onSelectChange,
  };

  const handleSend = async () => {
    if (employeeIds.length === 0) {
      AdnMessageError(t("welcomeSession.messages.selectAtLeastOneConsultant"));
    } else if (
      welcomeSessionDateTime === null ||
      welcomeSessionDateTime === undefined
    ) {
      AdnMessageError(t("welcomeSession.messages.selectDateAndTime"));
    } else {
      await notifyConsultants({ employeeIds, welcomeSessionDateTime })
        .then((res) => {
          if (res.status == 200) {
            AdnMessageSuccess(t("welcomeSession.messages.consultantsNotified"));
          } else if (res && res.data && res.data.errors) {
            res.data.errors.map((e) => {
              AdnMessageError(e.message);
            });
          } else {
            AdnMessageError(
              t("welcomeSession.messages.couldNotNotifyConsultants")
            );
          }
        })
        .catch(() => {
          AdnMessageError(
            t("welcomeSession.messages.couldNotNotifyConsultants")
          );
        });
    }

    setModalVisible(false);
  };

  const handleWelcomeSessionExcel = async () => {
    await getWelcomeSessionExcel()
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const a = document.createElement("a");
        a.href = url;
        a.download = `${REPORT_NAME}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        AdnMessageError(t("welcomeSession.messages.couldNotGenerateReport"));
      });
  };

  return (
    <WelcomeSessionListForm
      title={title}
      totalRecords={totalRecords}
      employeesList={employeesList}
      rowSelection={rowSelection}
      employeeIds={employeeIds}
      setModalVisible={setModalVisible}
      modalVisible={modalVisible}
      handleSend={handleSend}
      setWelcomeSessionDateTime={setWelcomeSessionDateTime}
      handleWelcomeSessionExcel={handleWelcomeSessionExcel}
    />
  );
};

export default ManageWelcomeSessionListPage;
